import intl from 'react-intl-universal';
import Logger from 'js-logger';
import { localizationConstants } from '@lifesize/clients.localization';

const DEFAULT_LOCALE = localizationConstants.defaultLanguageId;

// BCP-47 style locale codes' prefixes used to match, unless more specificity required.
const locales = {
  'en': require('@lifesize/strings/signup/en.json'),
  'cs': require('@lifesize/strings/signup/cs.json'),
  'it': require('@lifesize/strings/signup/it.json'),
  'ko': require('@lifesize/strings/signup/ko.json'),
  'sv': require('@lifesize/strings/signup/sv.json'),
  'de': require('@lifesize/strings/signup/de.json'),
  'es': require('@lifesize/strings/signup/es.json'),
  'fi': require('@lifesize/strings/signup/fi.json'),
  'fr': require('@lifesize/strings/signup/fr.json'),
  'ja': require('@lifesize/strings/signup/ja.json'),
  'nl': require('@lifesize/strings/signup/nl.json'),
  'no': require('@lifesize/strings/signup/no.json'),
  'nb': require('@lifesize/strings/signup/no.json'),
  'pl': require('@lifesize/strings/signup/pl.json'),
  'pt': require('@lifesize/strings/signup/pt.json'),
  'ru': require('@lifesize/strings/signup/ru-RU.json'),
  'zh-hant': require('@lifesize/strings/signup/zh-Hant.json'),
  'zh-tw': require('@lifesize/strings/signup/zh-Hant.json'),
  'zh': require('@lifesize/strings/signup/zh.json'),
  'zh-hans': require('@lifesize/strings/signup/zh.json'),
  'zh-cn': require('@lifesize/strings/signup/zh.json'),
};

const loadLocales = async (locale: string) => {
  // Ensure that translation exists, otherwise fallback to two-letter code, or default
  const lowerDefaultLocale = DEFAULT_LOCALE.toLowerCase();
  const defaultShortCode = lowerDefaultLocale.substring(0,2);
  const defaultLocale = (locales.hasOwnProperty(lowerDefaultLocale) && lowerDefaultLocale) || defaultShortCode;

  const lowerLocale = locale && locale.toLowerCase();
  const shortCode = lowerLocale && lowerLocale.substring(0,2);
  const appLocale = (locales.hasOwnProperty(lowerLocale) && lowerLocale) ||
    (locales.hasOwnProperty(shortCode) && shortCode) ||
    defaultLocale;
  new Promise(async resolve => {
    await intl.init({
      currentLocale: appLocale,
      locales,
      fallbackLocale: defaultLocale
    });
    Logger.info('Language initialized to: ' + appLocale);
    Logger.info('Language fallback initialized to: ' + defaultLocale);
    resolve(true);
  });
};

const determineBrowserLocale = () => {
  const browserLang = navigator.language;
  const params = new URL((window.location as unknown) as string).searchParams;
  const uriLang = params.get('lang');
  return uriLang || browserLang;
};

export {
  loadLocales,
  determineBrowserLocale
};
